function SFPageSelect(element) {
  var dom_element = element.get(0);
  if (dom_element.$dynamicSelect) {
    return;
  }
  dom_element.$SFPageSelect = this;
  this.$SFPageSelect = element;
  this._bindEvents();
}

SFPageSelect.prototype._bindEvents = function() {
  this.$SFPageSelect.on("change", $.proxy(this._changePage, this));
};

SFPageSelect.prototype._changePage = function() {
  window.location.href = this.$SFPageSelect.find(" option:selected").attr("data-url-dest");
};

$(function() {
  $("[data-sf-page-select]").each(function(index, element) {
    new SFPageSelect($(element));
  });
});
